import React, { useEffect } from 'react';
import { Container, Typography, Box } from '@mui/material';

function Purchase() {
  useEffect(() => {
    // Load the Shopify Buy Button script
    const script = document.createElement('script');
    script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    script.async = true;

    script.onload = () => {
      // Check if ShopifyBuy is available
      if (window.ShopifyBuy) {
        const client = window.ShopifyBuy.buildClient({
          domain: '2r4egf-ti.myshopify.com', // Replace with your Shopify store domain
          storefrontAccessToken: 'c593925e500f8ee9452d3b66a2ff76c7', // Replace with your Storefront Access Token
        });

        const ui = window.ShopifyBuy.UI.init(client);
        
        // Check if the Buy Button has already been created
        const buyButtonContainer = document.getElementById('buy-button-container');
        if (buyButtonContainer.childNodes.length === 0) {
          ui.createComponent('product', {
            id: '8761787154650', // Replace with your product ID
            node: buyButtonContainer,
            moneyFormat: '%24%7B%7Bamount%7D%7D',
            options: {
              // Add your options here
            },
          });
        }
      } else {
        console.error('ShopifyBuy SDK not loaded');
      }
    };

    document.head.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <Container sx={{ mt: 4, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Purchase Your Course
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Welcome to the purchase page! Here you can buy access to our comprehensive course materials designed to help you excel in the CCC Junior competition. 
        Our resources include detailed solutions, explanations, to enhance your skills. You will also be able to access a Python cheatsheet particularly created for solving Junior question 1 to 4. After purchase, we will send you an access code to sign up!
      </Typography>
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          mt: 2 
        }}
      >
        <div id="buy-button-container"></div> {/* This is where the Buy Button will be rendered */}
      </Box>
    </Container>
  );
}

export default Purchase; 